import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import PlusThin from '../../../../assets/icons/PlusThin';
import {STATIC_IMAGE} from '../../../../config/config';
import {useTimetableDays} from '../../hooks/useTimetableDays';
import * as css from './EmptyDay.css';

const emptyDayImage = `${STATIC_IMAGE}/app/timetable/pageNoLectures.png`;

interface EmptyDayProps {
    onAddLecture: () => void;
}

function EmptyDay({onAddLecture}: EmptyDayProps) {
    const {t} = useTranslation('timetable');
    const {currentDateLabel} = useTimetableDays();

    return (
        <css.card>
            <css.content>
                <css.image src={emptyDayImage} alt="" />
                <css.title>{t('noLectures')}</css.title>
                <css.description>{t('noLecturesDescription', {day: currentDateLabel})}</css.description>
            </css.content>
            <css.actions>
                <Button variant="brand" size="category" iconStart={<PlusThin />} onClick={onAddLecture}>
                    {t('addLecture')}
                </Button>
            </css.actions>
        </css.card>
    );
}

export default EmptyDay;
